import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { MdClose, MdEdit } from 'react-icons/md';
import client from '../api/client';
import FraseAlexa, { useParla } from './FraseAlexa';

// Il bottone «@» del campo di scrittura (04/10/2026: «le automazioni dovrebbero potersi visualizzare nella chat
// dove sono attive»). Mostra i comandi che valgono in questa chat e, come informazione, le regole senza parola
// che agiscono qui. Un tocco mette la parola nel campo; @alexa apre l'editor delle frasi.
export function useComandiQui(contactId) {
  const [dati, setDati] = useState(null);
  useEffect(() => {
    let vivo = true;
    setDati(null);
    if (contactId) {
      client.get('/v1/comandi-qui/', { params: { contact: contactId } })
        .then(({ data }) => { if (vivo) setDati(data); })
        .catch(() => { if (vivo) setDati(null); });
    }
    return () => { vivo = false; };
  }, [contactId]);
  return dati;
}

export default function ComandiQui({ dati, onScegli, onChiudi }) {
  const [alexa, setAlexa] = useState(null); // il comando @alexa, mentre si compone la frase
  const [frase, setFrase] = useState('');
  const frasi = useParla()?.frasi || [];
  const pannello = useRef(null);
  useEffect(() => {
    const fuori = e => { if (pannello.current && !pannello.current.contains(e.target)) onChiudi(); };
    const esc = e => { if (e.key === 'Escape') onChiudi(); };
    document.addEventListener('pointerdown', fuori);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('pointerdown', fuori); document.removeEventListener('keydown', esc); };
  }, [onChiudi]);

  return <div ref={pannello} className="comandi-qui" role="dialog" aria-label="Comandi in questa chat">
    <div className="comandi-qui-testa">
      <strong>{alexa ? 'Frase per Alexa' : 'Comandi in questa chat'}</strong>
      <button type="button" className="icon-button" aria-label="Chiudi" onClick={onChiudi}><MdClose size={20} /></button>
    </div>
    {alexa ? <div className="comandi-qui-corpo space-y-3">
      {frasi.length > 0 && <div className="flex flex-wrap gap-2" aria-label="Frasi salvate">
        {frasi.map(f => <button type="button" key={f.id} className="rounded-full border px-3 py-1 text-sm"
          onClick={() => onScegli(`${alexa.parola} (frase ${f.nome})`)}>💬 {f.nome}</button>)}
      </div>}
      <FraseAlexa valore={frase} onChange={setFrase} prova={false} etichetta={alexa.parola} />
      <div className="flex gap-2 justify-end">
        <button type="button" className="rounded-lg border px-4 py-2 text-sm" onClick={() => setAlexa(null)}>Indietro</button>
        <button type="button" className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
          disabled={!frase.trim()} onClick={() => onScegli(`${alexa.parola} ${frase}`)}>Metti nel messaggio</button>
      </div>
    </div> : <div className="comandi-qui-corpo">
      {dati.comandi.length > 0 && <ul className="comandi-qui-elenco">
        {dati.comandi.map(c => <li key={c.id}>
          <button type="button" className="comandi-qui-voce"
            onClick={() => (c.azione === 'home.speak' ? setAlexa(c) : onScegli(`${c.parola} `))}>
            <span className="comandi-qui-parola">{c.parola}</span>
            <span className="min-w-0">
              <span className="block text-sm text-ink">{c.cosa}</span>
              <span className="block text-xs text-muted">
                {c.chi === 'tu' ? 'Lo usi tu' : `Lo usano ${c.chi}`}{c.esempio ? ` · es. «${c.esempio}»` : ''}
              </span>
            </span>
          </button>
          <Link to={`/automations/${c.id}`} className="icon-button" aria-label={`Modifica la regola ${c.nome}`}><MdEdit size={18} /></Link>
        </li>)}
      </ul>}
      {dati.info.length > 0 && <ul className="comandi-qui-info">
        {dati.info.map(i => <li key={i.id}><Link to={`/automations/${i.id}`}>{i.frase}</Link></li>)}
      </ul>}
    </div>}
  </div>;
}
